<div class="relative">
  <router-outlet></router-outlet>

  @if (!applicationStore.authenticated()) {
    <div class="absolute z-100 top-50 right-1/2 -translate-y-1/2">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
